import { defineMessages, type MessageDescriptor } from 'react-intl'

/** Shared so the visible notice and the live region cannot drift into saying different things. */
const thingsToDoNotices = defineMessages({
  nearest: {
    id: 'mesn7PW32MJnRspLiAzI',
    defaultMessage: 'No {category} in {destination} — showing the nearest',
    description: 'Notice shown above trip planner things to do results when every place found sits outside the destination',
  },
  partial: {
    id: 'tqgjST4UfVTLFL0edXhm',
    defaultMessage: 'Some places couldn’t be loaded, so this list may be short.',
    description: 'Notice shown above the trip planner things to do list when one of the two place sources failed and the results are incomplete',
  },
  error: {
    id: 'cHlzhKIkYWUrVArgxaW7',
    defaultMessage: 'Failed to load things to do.',
    description: 'Error message shown when the trip planner things to do drawer cannot load any places',
  },
  emptyHeading: {
    id: 'zcsoUtQGoji8pC6hlgHs',
    defaultMessage: 'No {category} found in {destination}',
    description: 'Heading shown in the trip planner things to do drawer when a category search returns no places for the destination',
  },
  emptyBody: {
    id: 'kMZADU4UzZfziaGHscaX',
    defaultMessage: 'Try another category to see more places nearby.',
    description: 'Body copy shown in the trip planner things to do drawer when a category search returns no places for the destination',
  },
})

export default thingsToDoNotices

interface ThingsToDoNoticeState {
  isLoading: boolean
  isError: boolean
  isPartial: boolean
  isShowingNearest: boolean
  placeCount: number
}

/** Which single notice the tab is currently showing, in the order they take precedence. */
export function activeThingsToDoNotice({
  isLoading,
  isError,
  isPartial,
  isShowingNearest,
  placeCount,
}: ThingsToDoNoticeState): MessageDescriptor | undefined {
  if (isLoading) return undefined
  if (isError) return thingsToDoNotices.error
  if (placeCount === 0 && !isPartial) return thingsToDoNotices.emptyHeading
  if (isPartial) return thingsToDoNotices.partial
  if (isShowingNearest) return thingsToDoNotices.nearest
  return undefined
}
